import { useState, useEffect } from "react"
import { MainWrapper } from "../../common/MainWrapper"
import { StyledMainTitle } from "../styled"
import { Link, useNavigate } from "react-router-dom"
import Header from "../../common/Header"

const Panel = ({ user }) => {
  const [auth, setAuth] = useState("")
  const navigate = useNavigate()

  useEffect(() => {
    const auth = localStorage.getItem("UserName")
    setAuth(auth)
    if (user === "true") {
      navigate("/panel")
    }
  }, [user, navigate])

  return (
    <>
      <Header user={user} />
      <MainWrapper>
        <StyledMainTitle>Ewidencja Czasu Pracy</StyledMainTitle>
        <h5 className="text-primary m-2">Cześć, {auth}</h5>
        <div className="container-fluid">
          <div className="row justify-content-center">
            <Link
              to="/insday"
              className="col-md-2 btn btn-primary btn-lg m-2 p-3"
              role="button"
            >
              Wprowadź dzień
            </Link>

            <Link
              to="/alldays"
              className="col-md-2 btn btn-primary btn-lg m-2 p-3"
              role="button"
            >
              Pokaż listę dni
            </Link>

            <Link
              to="/result"
              className="col-md-2 btn btn-primary btn-lg m-2 p-3"
              role="button"
            >
              Pokaż zarobki
            </Link>

            <Link
              to="/statments"
              className="col-md-2 btn btn-primary btn-lg m-2 p-3"
              role="button"
            >
              Pokaż zestawienia
            </Link>

            <Link
              to="/invoiceslist"
              className="col-md-2 btn btn-primary btn-lg m-2 p-3"
              role="button"
            >
              Pokaż listę faktur
            </Link>
          </div>
        </div>
      </MainWrapper>
    </>
  );
}

export default Panel
